import apiClient from '../axios';
import _ from "lodash";

export async function list(countryId, page, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';
  const pageQuery = page && page > 0 ? `page=${page}` : (page && page < 0 ? 'no_pagination=true' : '');

  if (!_.isEmpty(filter)) {

    return apiClient
      .post(`/country/${countryId}/finalists?${pageQuery}${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
  }

  return apiClient
    .get(`/country/${countryId}/finalists?${pageQuery}${sortingQuery}`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function members(countryId, page, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';
  const pageQuery = page && page > 0 ? `page=${page}` : (page && page < 0 ? 'no_pagination=true' : '');

  return apiClient
      .post(`/country/${countryId}/finalists/members?${pageQuery}${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function contacts(countryId, page, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';
  const pageQuery = page && page > 0 ? `page=${page}` : (page && page < 0 ? 'no_pagination=true' : '');

  return apiClient
      .post(`/country/${countryId}/finalists/contacts?${pageQuery}${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function parents(countryId, page, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';
  const pageQuery = page && page > 0 ? `page=${page}` : (page && page < 0 ? 'no_pagination=true' : '');

  return apiClient
      .post(`/country/${countryId}/finalists/parents?${pageQuery}${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function printContacts(countryId, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/finalists/contacts/print?${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function printParents(countryId, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/finalists/parents/print?${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function printMembers(countryId, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/finalists/members/print?${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function print(countryId, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/finalists/print?${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function exportRegistrations(countryId, sorting, filter, format, name) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/finalists/export/${format}?${sortingQuery}`, filter, {
        responseType: 'blob',
      })
      .then(response => {
        if (response) {

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${name}.${format}`);
          document.body.appendChild(link);
          link.click();

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function exportRegistrationsMembers(countryId, sorting, filter, format, name) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/finalists/members/export/${format}?${sortingQuery}`, filter, {
        responseType: 'blob',
      })
      .then(response => {
        if (response) {

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${name}.${format}`);
          document.body.appendChild(link);
          link.click();

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function exportRegistrationsContacts(countryId, sorting, filter, format, name) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/finalists/contacts/export/${format}?${sortingQuery}`, filter, {
        responseType: 'blob',
      })
      .then(response => {
        if (response) {

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${name}.${format}`);
          document.body.appendChild(link);
          link.click();

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function exportRegistrationsParents(countryId, sorting, filter, format, name) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/finalists/parents/export/${format}?${sortingQuery}`, filter, {
        responseType: 'blob',
      })
      .then(response => {
        if (response) {

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${name}.${format}`);
          document.body.appendChild(link);
          link.click();

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function emails(countryId, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/finalists/emails?${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function emailsConfirmation(countryId, sorting, filter, data) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/finalists/emails/confirmation?${sortingQuery}`, {...filter, ...data})
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function details(countryId, id) {
  return apiClient
    .get(`/country/${countryId}/finalists/${id}`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function move(countryId, id) {
  return apiClient
    .get(`/country/${countryId}/finalists/${id}/move`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function add(data) {
  return apiClient
    .put(`/country/${data.countryId}/finalists`, data)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function edit(countryId, id, data) {
  return apiClient
    .post(`/country/${countryId}/finalists/${id}`, data)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function remove(countryId, id) {
  return apiClient
    .delete(`/country/${countryId}/finalists/${id}`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function changeIsDeactivated(id, isDeactivated) {
  return apiClient
    .post(`/finalists/${id}`, {is_deactivated: isDeactivated})
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}
